import { createSlice } from "@reduxjs/toolkit";
import moment from "moment";

export const timelineSlice = createSlice({
  name: "timeline",
  initialState: {
    fromDate: null,
    toDate: null,
    month: moment().format("MMMM"),
  },
  reducers: {
    addFromDate: (state, action) => {
      state.fromDate = action.payload;
    },
    addToDate: (state, action) => {
      state.toDate = action.payload;
    },
  },
});

// Export Actions
export const { addFromDate, addToDate } = timelineSlice.actions;

// Export Reducer
export default timelineSlice.reducer;
